<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <EditFormDialog
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :disabled="editFormDialogOptions.disabled"
      :funcID="editFormDialogOptions.funcID"
      :labelKey="editFormDialogOptions.labelKey"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditFormDialog from '../edit-form/dialog.vue'

export default {
  components: {
    PageHeader,
    PageMain,
    EditFormDialog,
  },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .merchantFunctionFormLanguageListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, row = {} }) {
      const { funcID, labelKey } = row
      const types = {
        edit:
          this.$l('merchant_function_form_language_edit') || '编辑多语言配置',
        add: this.$l('merchant_function_form_language_add') || '增加多语言配置',
        detail:
          this.$l('merchant_function_form_language_detail') || '多语言配置详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        disabled: type === 'detail',
        funcID,
        labelKey,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
